import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { Icon } from "@/elements-react/fix-icon";
import { FixButton } from "@/elements-react/fix-button";
import FixButtonDefault from "@/elements-react/fix-button-default";

export interface ConfirmDialogProps {
  text: string;
  onAccept: () => void;
  onCancel: () => void;
  acceptLabel?: string;
  cancelLabel?: string;
  className?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ text, onAccept, onCancel, acceptLabel, cancelLabel, className }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.overlay} onClick={onCancel} />
      <div className={styles.dialog} role="dialog" aria-modal="true">
        <div className={styles.content}>
          <div className={styles.text}>{text}</div>
          <div className={styles.actions}>
            <FixButton variant="primary" className={styles.cancel} onClick={onCancel}>
              {cancelLabel || t("p2pq4557h1g0pjmh.no", "No")}
            </FixButton>

            <FixButtonDefault className={styles.accept} onClick={onAccept} fullWidth={false} variant={'neutral'}>
              {acceptLabel || t("2jzj26gbdbh5o820.yes", "Yes")}
            </FixButtonDefault>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
